import { useEffect } from 'react';
import { Box, Chip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import { useBeneficiosStore } from '../store/beneficiosStore';

export default function VacacionesVistaGeneralTab() {
  const { resumenVacaciones, loading, loadResumenVacaciones } = useBeneficiosStore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    loadResumenVacaciones();
  }, [loadResumenVacaciones]);

  const columns: GridColDef[] = [
    { field: 'nombreTrabajador', headerName: 'Trabajador', flex: 1, minWidth: isMobile ? 120 : 220 },
    ...(!isMobile ? [
      { field: 'fechaIngreso', headerName: 'Fecha Ingreso', width: 120,
        valueFormatter: (value: string) => value ? new Date(value).toLocaleDateString('es-PE') : '' },
    ] : []),
    { field: 'totalDiasPendientes', headerName: isMobile ? 'Pend.' : 'Pendientes', width: isMobile ? 70 : 100, type: 'number',
      cellClassName: 'font-bold' },
    ...(!isMobile ? [
      { field: 'totalDiasGozados', headerName: 'Gozados', width: 90, type: 'number' as const },
      { field: 'totalDiasVendidos', headerName: 'Vendidos', width: 90, type: 'number' as const },
      { field: 'periodosPendientes', headerName: 'Per. Pend.', width: 100, type: 'number' as const },
    ] : []),
    { field: 'periodosPorVencer', headerName: isMobile ? 'Vencer' : 'Por Vencer', width: isMobile ? 80 : 110,
      renderCell: (params) => {
        const val = params.value as number;
        if (val === 0) return <span>0</span>;
        return <Chip label={val} size="small" color="warning" />;
      },
    },
  ];

  return (
    <Box>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
        {isMobile ? 'Resumen de vacaciones' : 'Resumen de vacaciones de todos los trabajadores activos'}
      </Typography>
      <DataGrid
        rows={resumenVacaciones}
        columns={columns}
        getRowId={(row) => row.idTrabajador}
        autoHeight
        density="compact"
        loading={loading}
        disableRowSelectionOnClick
        pageSizeOptions={[10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
      />
    </Box>
  );
}
